import React from "react";
import { Button, Container, Nav, Navbar, NavbarBrand, NavItem } from "reactstrap";

interface AuthHeaderProps {
  logoSrc: string;
  logoStyle?: React.CSSProperties;
  onClickLogo?: () => void;
  onClickLanguage?: () => void;
  languageTitle?: string;
}

const AuthHeader: React.FC<AuthHeaderProps> = ({
  logoSrc,
  logoStyle,
  onClickLogo,
  onClickLanguage,
  languageTitle = "Change language",
}) => {
  return (
    <Navbar
      className="navbar-horizontal navbar-main navbar-light navbar-transparent"
      expand="lg"
      style={{
        backgroundColor: "transparent",
      }}
    >
      <Container className="px-4">
        <NavbarBrand onClick={onClickLogo} style={{ cursor: "pointer" }}>
          <img src={logoSrc} alt="Logo" style={logoStyle} />
        </NavbarBrand>

        <Nav className="ml-auto align-items-center" navbar>
          <NavItem>
            <Button
              color="link"
              className="text-white"
              onClick={onClickLanguage}
              style={{
                fontSize: "1.25rem",
                textDecoration: "none",
                padding: "0.5rem 1rem",
              }}
              aria-label={languageTitle}
              title={languageTitle}
            >
              <i className="fas fa-globe" aria-hidden="true" />
            </Button>
          </NavItem>
        </Nav>
      </Container>
    </Navbar>
  );
};

export default AuthHeader;
